import { inventoryItemIdFormat } from "@redotech/redo-ids-cockroach";
import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import * as z from "zod";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  barcodeLabelSize as licensePlateLabelSize,
  type BarcodeLabelSize as LicensePlateLabelSize,
} from "@redotech/redo-model/inventory/barcode-label";

export const printLicensePlate = {
  name: "printLicensePlate" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    labelSize: z.enum(barcodeLabelSize).optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    printInventoryLabel: z.boolean().optional(),
    print3plLabel: z.boolean().optional(),
  }),
  output: z.object({
    inventoryPdfDataUrl: z.string().optional(),
    threePlPdfDataUrl: z.string().optional(),
    receivingPdfDataUrl: z.string().optional(),
    inventoryItemId: inventoryItemIdFormat.schema,
    barcodeValue: z.string(),
    sku: z.string().nullable(),
    printed: z.boolean().optional(),
  }),
};
